import { projectTypeLabel as sharedProjectTypeLabel } from '@/_shared/lib/project-type';

export function projectTypeLabel(type: string): string {
  if (type === 'unknown') return 'Detecting';
  // Settings has historically displayed Cube's stored value in lowercase.
  if (type === 'cube') return type;
  return sharedProjectTypeLabel(type) || 'Project';
}
